import {
  Cross
} from "./chunk-STJ6A5EM.mjs";

// src/dialog/src/dialog-elements/DialogSet.tsx
import { Close, Content, Overlay, Portal } from "@radix-ui/react-dialog";
import { forwardRef, useCallback } from "react";
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var DialogSet = forwardRef(
  ({
    children,
    closeLabel,
    onPointerDownOutside: onPointerDownOutsideExternal,
    width = "default",
    ...props
  }, ref) => {
    const onPointerDownOutsideInternal = useCallback(
      (e) => {
        const currentTarget = e.currentTarget;
        if (e.detail.originalEvent.offsetX > currentTarget.clientWidth) {
          e.preventDefault();
        }
        if (onPointerDownOutsideExternal) {
          onPointerDownOutsideExternal(e);
        }
      },
      [onPointerDownOutsideExternal]
    );
    const contentClassName = cx(
      "relative w-[90vw] rounded-lg bg-surface-light p-6 shadow-[0_2px_16px_0_rgba(85,85,90,0.16)] focus:outline-none",
      {
        "max-w-[1152px]": width === "wide",
        "max-w-[600px]": width === "default",
        "max-w-fit": width === "fit"
      }
    );
    return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Overlay, { className: "fixed inset-0 z-40 grid place-items-center overflow-y-auto bg-surface-dark/[.2] px-6 py-32", children: /* @__PURE__ */ jsxs(
      Content,
      {
        className: contentClassName,
        ...props,
        ref,
        onPointerDownOutside: onPointerDownOutsideInternal,
        children: [
          children,
          Boolean(closeLabel) && /* @__PURE__ */ jsx(
            Close,
            {
              "aria-label": closeLabel,
              className: "absolute right-6 top-6 rounded focus:outline-none focus:ring-2 focus:ring-interactive-focus",
              children: /* @__PURE__ */ jsx(Cross, {})
            }
          )
        ]
      }
    ) }) });
  }
);

export {
  DialogSet
};
